import { render, staticRenderFns } from "./HoC2018Component.vue?vue&type=template&id=f956af94&lang=pug&"
import script from "./HoC2018Component.vue?vue&type=script&lang=js&"
export * from "./HoC2018Component.vue?vue&type=script&lang=js&"
import style0 from "./HoC2018Component.vue?vue&type=style&index=0&id=f956af94&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports